import React from 'react';

const Process = () => {
  const steps = [
    {
      letter: 'D',
      number: '1',
      title: 'Discover',
      description: 'We align on outcomes, constraints, and risk—from infrastructure audits to product vision—so priorities reflect reality, not slides alone.',
    },
    {
      letter: 'D',
      number: '2',
      title: 'Document',
      description: 'Requirements, architecture decisions, and security or compliance checkpoints captured so delivery stays traceable and stakeholders stay aligned.',
    },
    {
      letter: 'D',
      number: '3',
      title: 'Develop',
      description: 'We develop the needed solution using agile methodologies.',
    },
    {
      letter: 'D',
      number: '4',
      title: 'Deploy',
      description: 'Secure, repeatable releases to cloud or on-prem—pipelines, environments, and observability matched to your maturity.',
    },
    {
      letter: 'D',
      number: '5',
      title: 'Drive',
      description: 'Handoff, managed operations, or co-managed runbooks—so improvements continue after go-live, not only during the build.',
    }
  ];

  return (
    <section id="process" className="process-clean">
      <div className="container">
        <div className="process-header-clean">
          <h2 className="process-title-clean">
            How we work
          </h2>
          <h3 className="process-subtitle-clean">
            From audit to run-state
          </h3>
          <h4 className="process-subtitle-small-clean">
            clarity at every step
          </h4>
        </div>

        <div className="process-approach-clean">
          <div className="process-approach-label">5D</div>
          <div className="process-approach-text">approach</div>
        </div>

        <div className="process-steps-clean">
          {steps.map((step, index) => (
            <div key={index} className="process-step-clean">
              <div className="process-step-header-clean">
                <div className="process-step-letter-clean">{step.letter}</div>
                <div className="process-step-number-clean">{step.number}</div>
              </div>
              <h3 className="process-step-title-clean">{step.title}</h3>
              <p className="process-step-description-clean">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="process-footer-clean">
          <p className="process-footer-text-clean">
            From first audit through run-state operations, we keep delivery clear and outcomes measurable—so your teams stay focused on the mission, not the backlog.
          </p>
          <div className="process-footer-tagline-clean">
            #TogetherWeDevelopYourSuccess
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;

